import { Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Resonance", href: "#", desc: "Depth-first connection" },
  { label: "Groundwork", href: "#", desc: "Daily mental wellness" },
  { label: "Compass", href: "#", desc: "Values-based career clarity" },
  { label: "Privacy Policy", href: "/privacy", desc: "" },
  { label: "Contact", href: "mailto:hello@depthco.app", desc: "" },
];

export default function FooterSection() {
  return (
    <footer
      data-testid="footer-section"
      className="py-16 px-6"
      style={{
        backgroundColor: "var(--charcoal)",
        color: "rgba(253,246,240,0.85)",
      }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Top: Logo + Tagline */}
        <div className="flex flex-col items-center mb-12">
          {/* Logo mark: concentric circles */}
          <div className="flex items-center gap-3 mb-3">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              aria-hidden="true"
            >
              <circle cx="16" cy="16" r="15" stroke="#D85A30" strokeWidth="1.2" opacity="0.3" />
              <circle cx="16" cy="16" r="10" stroke="#D85A30" strokeWidth="1.2" opacity="0.5" />
              <circle cx="16" cy="16" r="5" stroke="#D85A30" strokeWidth="1.5" opacity="0.8" />
              <circle cx="16" cy="16" r="1.5" fill="#D85A30" />
            </svg>
            <span
              data-testid="footer-logo"
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "1.5rem",
                fontWeight: 600,
                color: "rgba(253,246,240,0.95)",
              }}
            >
              Depth Co.
            </span>
          </div>
          <p
            data-testid="footer-tagline"
            style={{
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontSize: "1rem",
              color: "rgba(253,246,240,0.6)",
            }}
          >
            Technology with soul
          </p>
        </div>

        {/* Links */}
        <div
          data-testid="footer-links"
          className="flex flex-wrap justify-center gap-8 sm:gap-12 mb-12"
          style={{ fontFamily: "var(--font-sans)" }}
        >
          {footerLinks.map(({ label, href, desc }) => {
            const linkStyle = {
              color: "rgba(253,246,240,0.6)",
              textDecoration: "none",
              transition: "color 0.2s ease",
              textAlign: "center",
            };
            const content = (
              <div className="flex flex-col items-center gap-1">
                <span style={{ fontSize: "0.875rem", fontWeight: 500 }}>{label}</span>
                {desc && (
                  <span style={{ fontSize: "0.7rem", opacity: 0.6, fontWeight: 400 }}>{desc}</span>
                )}
              </div>
            );
            return href.startsWith("/") ? (
              <Link
                key={label}
                to={href}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "rgba(253,246,240,0.95)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(253,246,240,0.6)")}
              >
                {content}
              </Link>
            ) : (
              <a
                key={label}
                href={href}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                style={linkStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "rgba(253,246,240,0.95)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(253,246,240,0.6)")}
              >
                {content}
              </a>
            );
          })}
        </div>

        {/* Social Icons */}
        <div className="flex justify-center gap-5 mb-10">
          <a
            data-testid="footer-instagram"
            href="https://instagram.com/depthco_app"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "rgba(253,246,240,0.5)",
              transition: "color 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#D85A30")}
            onMouseLeave={(e) => (e.target.style.color = "rgba(253,246,240,0.5)")}
            aria-label="Instagram"
          >
            <Instagram size={20} />
          </a>
          <a
            data-testid="footer-linkedin"
            href="https://linkedin.com/company/depthco"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "rgba(253,246,240,0.5)",
              transition: "color 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#D85A30")}
            onMouseLeave={(e) => (e.target.style.color = "rgba(253,246,240,0.5)")}
            aria-label="LinkedIn"
          >
            <Linkedin size={20} />
          </a>
        </div>

        {/* Copyright */}
        <p
          data-testid="footer-copyright"
          className="text-center"
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: "0.8rem",
            color: "rgba(253,246,240,0.35)",
          }}
        >
          &copy; 2025 Depth Co. — Built in Sydney, Australia
        </p>
      </div>
    </footer>
  );
}
